"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const coffeescript_1 = require("coffeescript");
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const append_empty_line_1 = require("./append-empty-line");
const build_1 = require("./build");
const cellify_1 = require("./cellify");
const CodeCell_1 = require("./CodeCell");
require("./completion");
const store_1 = require("./store");
const code_view_scss_1 = __importDefault(require("./styles/code-view.scss"));
const flex_scss_1 = __importDefault(require("./styles/flex.scss"));
const TextCell_1 = require("./TextCell");
function CodeView({ code, handleRun }) {
    const dispatch = react_redux_1.useDispatch();
    const cellsRef = React.useRef(cellify_1.cellify(code)); // Notice: mutable
    for (let cell of cellsRef.current) {
        if (cell.type === 'code') {
            formatCodeCell(cell);
        }
    }
    const onUpdate = React.useCallback(({ id, value }) => {
        const cells = cellsRef.current;
        const cell = cells.find(cell => cell.id === id);
        if (!cell)
            throw new Error(`Cell not found. cell=${id}`);
        // Test && Save
        try {
            if (cell.type === 'code') {
                coffeescript_1.CoffeeScript.compile(value); // syntax check
            }
        }
        catch (error) {
            return console.warn(error);
        }
        // Update cells
        if (cell.type === 'code') {
            cell.value = value;
        }
        else if (cell.type === 'text') {
            cell.value = value;
            cell.nodes = cellify_1.blockify(value);
        }
        dispatch(store_1.actions.writeFiles([
            {
                name: 'modules/プレイヤー.js',
                type: 'application/javascript',
                code: build_1.build(cells)
            }
        ]));
    }, []);
    React.useEffect(() => {
        dispatch(store_1.actions.writeFiles([
            {
                name: 'modules/プレイヤー.js',
                type: 'application/javascript',
                code: build_1.build(cellsRef.current)
            }
        ]));
        dispatch(store_1.actions.runSanbox());
    }, []);
    const fileInfo = {
        iconUrl: 'https://assets.hackforplay.xyz/img/6d152a956071fc7b2e7ec0c8590146e4.png',
        name: {
            ja: 'プレイヤー'
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classnames_1.default(code_view_scss_1.default.header, flex_scss_1.default.horizontal) },
            React.createElement("img", { src: fileInfo.iconUrl, alt: "", className: code_view_scss_1.default.icon }),
            React.createElement("div", { className: code_view_scss_1.default.name }, fileInfo.name.ja),
            React.createElement(PaperPlane, { handleRun: handleRun })),
        cellsRef.current.map(cell => cell.type === 'code' ? (React.createElement(CodeCell_1.CodeCell, { key: cell.id, id: cell.id, value: cell.value, title: cell.meta, onUpdate: onUpdate })) : (React.createElement(TextCell_1.TextCell, { key: cell.id, id: cell.id, nodes: cell.nodes, onUpdate: onUpdate })))));
}
exports.CodeView = CodeView;
function formatCodeCell(codeCell) {
    codeCell.value = append_empty_line_1.appendEmptyLine(codeCell.value);
}
function PaperPlane({ handleRun }) {
    const lv = react_redux_1.useSelector((state) => state.sandbox.localVersion);
    const rv = react_redux_1.useSelector((state) => state.sandbox.runningVersion);
    return (React.createElement("div", { className: classnames_1.default(code_view_scss_1.default.plane, lv <= rv && code_view_scss_1.default.sent) },
        React.createElement("img", { src: require('./resources/paperPlane.svg'), alt: "\u2708", onClick: handleRun })));
}
